import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_sanitario/presentacion';
import Presentacion from './PresentacionList';


const ms2p = (state) => {
  return {
    ...state.rs_presentacion,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Presentacion);